export const agatePartnership230315 = {
  en: {
    subject: "[Partnership] NEOPIN signs partnership agreement with Agate",
    body: `NEOPIN has announced partnership with Agate, the largest game studio in Indonesia, to establish the Web 3.0 gaming ecosystem on 15 March. 

    Through this partnership, NEOPIN placed a main bridgestone to the SEA expansion of its own Web 3.0 game ecosystem. NEOPIN will leverage this partnership to expand its own Web 3.0  game ecosystem throughout Southeast Asia, with 8 games already or soon to be onboarded. Major games in the ecosystem will target the Indonesian market with Agate's support.`,
  },
};
